define.alias("shared/utils/uuid", "media/utils/uuid");